import { render, staticRenderFns } from "./FormBuilderElementEdit.vue?vue&type=template&id=68b293ee&"
import script from "./FormBuilderElementEdit.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElementEdit.vue?vue&type=style&index=0&id=68b293ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports